import { render, staticRenderFns } from "./cinema-table.vue?vue&type=template&id=f737628a&scoped=true"
import script from "./cinema-table.vue?vue&type=script&lang=js"
export * from "./cinema-table.vue?vue&type=script&lang=js"
import style0 from "./cinema-table.vue?vue&type=style&index=0&id=f737628a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f737628a",
  null
  
)

export default component.exports